function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import classnames from "classnames";
import BaseTemplate from "../base-template";
import SegmentsLayoutListComponent from "./segments-layout-list/segments-layout-list-component";
import CoreAddonsComponent from "/components/addons/core-addons/core-addons-component";
import { StyledDynamicTemplate } from "./dynamic-template.scss";
class DynamicTemplate extends PureComponent {
    render() {
        const { rootEl } = this.state;
        const { pageConfig, segmentComponents, isPreview, exitPopup, dynamicData } = this.props;
        const { segments, isMobile, templateClassName, exitPopupConfig } = pageConfig;
        return /*#__PURE__*/ _jsx(BaseTemplate, _object_spread_props(_object_spread({}, this.props, pageConfig), {
            children: /*#__PURE__*/ _jsxs(StyledDynamicTemplate, {
                ref: (el)=>this.setState({
                        rootEl: el
                    }),
                className: classnames("dynamic-template", templateClassName),
                children: [
                    /*#__PURE__*/ _jsx(SegmentsLayoutListComponent, {
                        isMobile: isMobile,
                        isPreview: isPreview,
                        segments: segments,
                        dynamicData: dynamicData,
                        segmentComponents: segmentComponents,
                        rootEl: rootEl
                    }),
                    /*#__PURE__*/ _jsx(CoreAddonsComponent, {
                        exitPopup: exitPopup,
                        exitPopupConfig: exitPopupConfig
                    })
                ]
            })
        }));
    }
    constructor(props){
        super(props);
        this.state = {
            rootEl: null
        };
    }
}
export { DynamicTemplate as default };
DynamicTemplate.defaultProps = {
    exitPopup: true,
    segmentComponents: []
};
